<template>
  <div class="videoMain" :class="{ videoScreen: $store.state.isMapScreen }">
    <Split v-model="split" min="0" max="400">
      <div slot="left" ref="left" class="demo-split-pane" style="height: 100%">
        <monitor-tree
          ref="fleetTree"
          modal="video"
          :isLive="true"
          :limit="4"
          filterGroup="车辆"
          @videoCmd="playObj"
        ></monitor-tree>
      </div>
      <div
        slot="right"
        class="demo-split-pane"
        ref="right"
        style="height: 100%"
      >
        <div id="left_right" @click="showHide">
          <Icon v-if="split == 0" type="md-arrow-dropright" />
          <Icon v-else type="md-arrow-dropleft" />
        </div>
        <my-video ref="vueVideo"></my-video>
      </div>
    </Split>
  </div>
</template>
<script>
import monitorTree from "../locate/locateToolCarPerson.vue";
import myVideo from "./bsjVideo.vue";
export default {
  props: ["leftLoteData"],
  data() {
    return {
      split: "240",
    };
  },
  computed: {
    litenIsMapScreen() {
      return this.$store.state.isMapScreen;
    },
  },
  components: {
    monitorTree,
    myVideo,
  },
  methods: {
    reSelectVehicle(v) {
      // this.$refs.postDevice.getGps(v);
      this.$emit("send", v);
      //
    },
    showHide() {
      if (this.split == 0) {
        this.setWidth();
        this.$refs.left.style.display = "block";
      } else {
        this.split = 0;
        this.$refs.left.style.display = "none";
      }
    },
    setHight() {
      //var height = document.body.clientHeight;
      // this.$refs.right.style.height = height - 50 + "px";
    },
    storeSplit() {
      localStorage.setItem("Split1", this.split);
    },
    playObj(obj) {
      if (obj.play) {
        this.$refs.vueVideo.open(obj);
      } else {
        this.$refs.vueVideo.pause(obj);
      }
    },
  },
  mounted() {
    // this.setHight();
    if (localStorage.getItem("Split1") == null) {
      // this.split = 0.1;
    } else {
      // this.split = Number(localStorage.getItem("Split1"));
    }
  },
  watch: {
    litenIsMapScreen(v) {
      if (v) {
        var height = window.screen.height;
        this.$refs.right.style.height = height + "px";
      } else {
        setTimeout(() => {
          var height = document.body.clientHeight;
          this.$refs.right.style.height = height - 50 + "px";
        }, 200);
      }
    },
  },
};
</script>
<style>
.videoMain {
  height: 100% !important;
  padding-top: 50px;
  text-align: left;
}
/*去除百度地图版权*/
.anchorBL {
  display: none;
}

.demo-split {
  position: relative;
  border: 1px solid #dcdee2;
}
#left_right {
  position: absolute;
  left: 0;
  top: 48%;
  background: #333;
  width: 18px;
  line-height: 60px;
  z-index: 200;
  color: #fff;
  font-size: 18px;
  border-radius: 0 4px 4px 0;
  cursor: pointer;
  opacity: 0.3;
}
#left_right:hover {
  opacity: 0.5;
}
.mapscreen {
  position: absolute;
  left: 0;
  top: 0;
  z-index: 6666;
  width: 100%;
  height: 100% !important;
  background: #f5f5f5;
  padding-top: 0 !important;
}
.videoScreen {
  position: absolute;
  left: 0;
  top: 0;
  z-index: 6666;
  width: 100%;
  height: 100% !important;
  background: #f5f5f5;
  padding-top: 0 !important;
}
</style>


// WEBPACK FOOTER //
// src/components/video/byVideo.vue